import React, { useRef, useCallback } from 'react';
import cn from 'classnames';
import { getAutoHeightDuration } from '../../../../_internal_/utils/getAutoHeightDuration';
import { useAnimation } from '../../../../hooks/useAnimation';
import { useIsomorphicLayoutEffect as useLayoutEffect } from '../../../../hooks/useIsomorphicLayoutEffect';
require("./DrawerBar.css");
var styles = {
  "Root": "DrawerBar-module-Root_2RF",
  "overlayMode": "DrawerBar-module-overlayMode_3VY"
};
const DrawerBar = ({
  children,
  onClose,
  open,
  style = {},
  id
}) => {
  const contentRef = useRef(null);
  const [{
    ty
  }, startOverlay] = useAnimation({
    tx: 0,
    ty: '100%'
  });
  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(() => startOverlay({
        ty: open ? '0px' : '100%'
      }));
    }
  }, [open, startOverlay]);
  const handleTransitionEnd = useCallback(e => {
    if (contentRef.current && !open) {
      onClose(e);
      startOverlay({
        ty: '100%'
      });
    }
  }, [onClose, open, startOverlay]);
  return /*#__PURE__*/React.createElement("dialog", {
    "aria-modal": open,
    open: open,
    className: cn(styles.Root, styles.overlayMode),
    ref: contentRef,
    onTransitionEnd: handleTransitionEnd,
    id: id,
    style: {
      ...style,
      transform: `translate3d(0px, ${ty}, 0px)`,
      transitionDuration: `${getAutoHeightDuration(contentRef.current?.clientHeight || 0)}ms`
    }
  }, children);
};
export default DrawerBar;